import Canada from "assets/icons/countries/Canada";
import Euro from "assets/icons/countries/Euro";
import UAE from "assets/icons/countries/UAE";
import Uk from "assets/icons/countries/Uk";
import USA from "assets/icons/countries/USA";

export const currencies = [
  {
    Flag: UAE,
    unit: "AED",
    currencyExchange: 7700,
    businessCurrencyId: 10,
  },
  {
    id: 253,
    Flag: USA,
    unit: "USD",
    currencyExchange: 32000,
    en_title: "$",
    label: "دلار آمریکا",
  },
  {
    Flag: Canada,
    unit: "CAD",
    currencyExchange: 23000,
  },
  {
    Flag: Uk,
    unit: "GBP",
    currencyExchange: 43000,
  },
  {
    id: 95,
    Flag: Euro,
    unit: "EURO",
    currencyExchange: 31000,
  },
];
